module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7083/images/default-avatar.png"